import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { Button, Card, CardContent, CircularProgress, TextField } from '@mui/material';
import { AppPage, AppToast } from '@shared';
import { ta } from 'utils';

const csrfToken = document.querySelector("meta[name=csrf-token]").content;

const propTypes = {
  submitURL: PropTypes.string.isRequired,
  loginUrl: PropTypes.string.isRequired
};

const ForgotPassword = (props) => {
  const [email, setEmail] = useState("")
  const [loading, setLoading] = useState(false);
  const [toast, setToast]= useState(props.errors.email ? props.errors.email[0] : "")

  const htmlForm = useRef(null);
  const submitForm = () => {
    setLoading(true);
    htmlForm.current.submit();
  }
  const dismissToast = () => setToast(false);
  return (
          <AppPage
              title="¿Olvidaste tu contraseña?"
          >
            <Card>
              <CardContent>
              <form
                ref={ htmlForm}
                action={ props.submitURL }
                method="post"
              >
                <TextField
                    fullWidth
                    label={ ta("user.email") }
                    placeholder="foo@bar.com"
                    name="user[email]"
                    value={ email }
                    onChange={ (event) => setEmail(event.target.value) }
                    InputLabelProps={{ shrink: true }}
                />
                <div  className="flex flexColumn justifyCenter mt4">
                  <Button
                      variant="contained"
                      type="submit"
                      fullWidth
                      disabled={loading}
                      startIcon={ loading ? <CircularProgress size={16} color="inherit" /> : null }
                      onClick={ submitForm }
                  >
                    Enviar
                  </Button>
                </div>
                <input type="hidden" name="authenticity_token" value={csrfToken} />
              </form>
              </CardContent>
            </Card>
            <div>
              { toast &&
                <AppToast content={toast} onDismiss={dismissToast} duration={3000}  />
              }
            </div>
          </AppPage>
  );

}

ForgotPassword.propTypes = propTypes;


export default ForgotPassword;
